// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable extra-rules/no-commented-out-code */
/* eslint-disable max-lines */
import { parseProductFromAPI } from '@tcp/core/src/components/features/browse/ProductListingPage/container/ProductListingPage.dataMassage';
/* eslint-disable no-shadow */
import { getImgPathWithExtension } from '@tcp/core/src/components/features/browse/ProductListingPage/util/utility';
import {
  getTopRatedAttributeToBeChecked,
  getBestSellerAttributeToBeChecked,
  getMostFavoritedAttributeToBeChecked,
  getShowBopisTileBasedOnStoreSpecials,
  allowOnlineProductPickup,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getStoreRef } from '@tcp/core/src/utils/store.utils';
import processHelpers from './processHelpers';
import {
  extractExtraImages,
  getAccessoriesData,
  isDuplicateColorsPresent,
} from './productListing.utils';
import {
  extractPrioritizedBadge,
  extractZoneOneBadges,
  extractZoneSixBadges,
} from '../../../utils/badge.util';

export function parseBoolean(bool) {
  return bool === true || bool === '1' || (bool || '').toUpperCase() === 'TRUE';
}
export const LANG_STRINGS = {
  PRODUCTS: {
    ATTRIBUTES: {
      CLEARANCE: {
        en: 'Clearance',
        fr: 'Liquidation',
        es: 'Liquidación',
      },
      ONLINE_ONLY: {
        en: 'Online Only',
        fr: 'Online Only', // Added english word as we dont have online only for ca-fr
        es: 'Solo en línea',
      },
      NEW_ARRIVALS: {
        en: 'New Arrivals',
        fr: 'Nouveautés',
        es: 'Novedades',
      },
    },
  },
};

function getAllLangConsts(categoryType) {
  return Object.keys(categoryType).map((key) => categoryType[key]);
}

// function to select the corresponding category
export function getClearanceString(categoryType) {
  return getAllLangConsts(LANG_STRINGS.PRODUCTS.ATTRIBUTES[categoryType]);
}

export function attributeListMaker(attributes) {
  if (attributes && Array.isArray(attributes)) {
    return attributes;
  }
  return (
    attributes &&
    attributes.split(`;`).map((attribute) => {
      const regexUrl = /((http|https):\/\/)?(([\w.-]*)\.([\w])).*/g;
      const isUrl = regexUrl.test(attribute);
      const match = attribute.match(regexUrl);
      const url = match && match[0].split('|');

      if (attribute?.split(':')[0] === 'kitGrouping') {
        const index = attribute?.indexOf(':');
        const key = attribute?.substring(0, index);
        const value = attribute?.substring(index + 1);
        return { identifier: key, value: JSON.parse(value) };
      }

      if (
        attribute.split(':')[0] === 'topRatedCategories' ||
        attribute.split(':')[0] === 'FeaturedCategories' ||
        attribute.split(':')[0] === 'mostFavoritedCategories' ||
        attribute.split(':')[0] === 'variantDetails'
      ) {
        const attrAndValue = attribute.split(/:(.*)/s);
        return { identifier: attrAndValue[0], value: attrAndValue[1] };
      }
      const attAndValue = attribute.split(`:`);
      return { identifier: attAndValue[0], value: isUrl ? url : attAndValue[1] };
    })
  );
}
export function extractAttributeValue(item, attribute) {
  try {
    if (item && item.list_of_attributes) {
      const currItm = item.list_of_attributes;
      /* item.list_of_attributes comes as Array on PLP but on PDP it comes as a string when this function is called. On PLP we have a wrapper funtion where
      we do the modifcation and pass the data to this function but on PDP we do not have a wrapper function in this module hence handeling the PDP at this
      place only. */
      const itm = Array.isArray(currItm) ? currItm : attributeListMaker(currItm);
      const attr = itm.find((att) => att.identifier === attribute);
      return attr ? attr.value : null;
    }
    if (item && item[attribute]) {
      return item[attribute];
    }
    return null;
  } catch (ex) {
    return '';
  }
}
const getListPrice = (swatchOfAvailableProduct) => {
  return swatchOfAvailableProduct.min_list_price === swatchOfAvailableProduct.min_offer_price
    ? swatchOfAvailableProduct.min_offer_price
    : swatchOfAvailableProduct.min_list_price ||
        {
          value: null,
        }.value ||
        0;
};
const getRating = (product) => {
  return product.TCPBazaarVoiceRating || 0;
};
const getReview = (product) => {
  return (
    (product.TCPBazaarVoiceReviewCount && parseInt(product.TCPBazaarVoiceReviewCount, 10)) || 0
  );
};
const getMiscInfoRating = (product) => {
  return parseFloat(product.TCPBazaarVoiceRating) || 0;
};
const getUnbxdIdFromReq = (headers) => {
  return headers && headers['unbxd-request-id'];
};
const getPromotionalMessage = (product) => {
  return product.TCPLoyaltyPromotionTextUSStore || '';
};
const getPromotionalPLCCMessage = (product) => {
  return product.TCPLoyaltyPLCCPromotionTextUSStore || '';
};
const catMapExists = (temp, catMap, bucketingSeqConfig) => {
  const desiredL2Val = bucketingSeqConfig.desiredL2 && bucketingSeqConfig.desiredL2.split('|')[0];
  return temp && catMap[desiredL2Val] && catMap[desiredL2Val].indexOf(temp) !== -1;
};

/* get the category name corresponding to least breadcrumb category id to pass to adobe */
export function getCategoryId(categoryPath, breadcrumb) {
  let categoryName;
  if (categoryPath && categoryPath.length) {
    categoryPath.some((values) => {
      const value = values.split('|');
      const id = value[0].split('>').indexOf(breadcrumb);

      categoryName = value[1].split('>')[id];
      if (categoryName) {
        return true;
      }
      return false;
    });
  }
  return categoryName;
}
const numericStringToBool = (str) => !!+str;
/**
 * @param {object} bossDisabledFlags carries the boss disability flags - bossCategoryDisabled, bossProductDisabled
 * @returns the disability boolean value
 */
export const isBossProduct = (bossDisabledFlags) => {
  const { bossCategoryDisabled, bossProductDisabled } = bossDisabledFlags;
  return !(numericStringToBool(bossCategoryDisabled) || numericStringToBool(bossProductDisabled));
};

/**
 * @function isBopisProduct
 * @summary This BOPIS logic is to validate if product/color variant is eligible for BOPIS
 * product is a color variant object of a product.
 */
export const isBopisProduct = (isUSStore, product) => {
  let isOnlineOnly;
  let storeSpecialsEnabled = false;
  let shouldAllowOnlineProductPickup = false;
  const attributesNames = processHelpers.getProductAttributes();

  if (getStoreRef()?.getState()) {
    storeSpecialsEnabled =
      getShowBopisTileBasedOnStoreSpecials(getStoreRef()?.getState()) &&
      parseBoolean(product?.store_specials);
    shouldAllowOnlineProductPickup = allowOnlineProductPickup(getStoreRef()?.getState());
  }

  if (isUSStore) {
    isOnlineOnly =
      (product &&
        product.TCPWebOnlyFlagUSStore &&
        parseBoolean(product.TCPWebOnlyFlagUSStore) &&
        !storeSpecialsEnabled) ||
      false; // validate if product is online only so it is not BOPIS eligible
  } else {
    isOnlineOnly =
      (product &&
        product.TCPWebOnlyFlagCanadaStore &&
        parseBoolean(product.TCPWebOnlyFlagCanadaStore) &&
        !storeSpecialsEnabled) ||
      false;
  }

  const tcpStyleType = extractAttributeValue(product, attributesNames.tcpStyle);
  if (shouldAllowOnlineProductPickup && tcpStyleType !== '0005' && tcpStyleType !== '0006') {
    return true;
  }
  return !isOnlineOnly;
};

function getColorNameForProductParser({ uniqueId, colorName, isFromProductParser, colors }) {
  const isDuplicate = isDuplicateColorsPresent(colors);
  return isDuplicate && isFromProductParser ? `${colorName}-${uniqueId}` : colorName;
}

export const getColorsMap = ({
  uniqueId,
  product,
  attributesNames,
  categoryType,
  excludeBadge,
  isBOPIS,
  bossDisabledFlags,
  defaultColor,
  getImgPath: getImagePath,
  isBundleProduct,
  state,
  isFromProductParser,
  colors,
}) => {
  return [
    {
      colorProductId: uniqueId,
      imageName: product.imagename,
      productImage: product.productimage,
      miscInfo: {
        bossDisabledFlags,
        isClearance: extractAttributeValue(product, attributesNames.clearance),
        isOnline: extractAttributeValue(product, attributesNames.onlineOnly),
        isBopisEligible: isBOPIS && !processHelpers.isGiftCard(product),
        isBossEligible: isBossProduct(bossDisabledFlags) && !processHelpers.isGiftCard(product),
        badge1: extractPrioritizedBadge(
          product,
          attributesNames,
          categoryType,
          excludeBadge,
          !isBundleProduct
        ),
        badge2: extractAttributeValue(product, attributesNames.extendedSize),
        badge3: extractAttributeValue(product, attributesNames.merchant),
        badge4: extractAttributeValue(product, attributesNames.FeaturedCategories),
        zoneOneBadges: extractZoneOneBadges(product, attributesNames, categoryType),
        zoneSixBadges: extractZoneSixBadges(
          product,
          attributesNames,
          categoryType,
          isBundleProduct
        ),
        topRatedSLP: extractAttributeValue(product, getTopRatedAttributeToBeChecked(state)),
        bestSellerSLP: extractAttributeValue(product, getBestSellerAttributeToBeChecked(state)),
        mostFavoritedSLP: extractAttributeValue(
          product,
          getMostFavoritedAttributeToBeChecked(state)
        ),
        videoUrl: extractAttributeValue(product, attributesNames.videoUrl),
        hasOnModelAltImages: extractAttributeValue(product, attributesNames.onModelAltImages)
          ? parseBoolean(extractAttributeValue(product, attributesNames.onModelAltImages))
          : false,
        listPrice: parseFloat(product.TCPCustomListPrice) || product.min_list_price,
        offerPrice: parseFloat(product.TCPCustomSalePrice) || product.min_offer_price,
        keepAlive: parseBoolean(product[attributesNames.keepAlive]),
      },
      color: {
        name: getColorNameForProductParser({
          uniqueId,
          colorName: defaultColor,
          isFromProductParser,
          colors,
        }),
        imagePath: getImagePath(isBundleProduct ? product.prodpartno : product.imagename)
          .colorSwatch,
        swatchImage: product.swatchimage || '',
      },
    },
  ];
};
const colorDetailsCondition = (productId, product, swatchOfAvailableProduct, uniqueId) => {
  return (
    productId &&
    productId !== product.imagename &&
    swatchOfAvailableProduct !== undefined &&
    uniqueId !== productId
  );
};
const isBopisEligibleProduct = (isUSStore, swatchOfAvailableProduct, product) => {
  return isBopisProduct(isUSStore, swatchOfAvailableProduct) && !processHelpers.isGiftCard(product);
};
const isBossEligibleProduct = (bossDisabledFlags, product) => {
  return isBossProduct(bossDisabledFlags) && !processHelpers.isGiftCard(product);
};
const isBossProductDisabled = (product) => {
  return (
    extractAttributeValue(product, processHelpers.getProductAttributes().bossProductDisabled) || 0
  );
};
const isBopisProductDisabled = (product) => {
  return (
    extractAttributeValue(product, processHelpers.getProductAttributes().bossCategoryDisabled) || 0
  );
};

/**
 * This function returns product part no or product id if product part no does not exists
 * @param {Object} product
 */
export const getGeneralProductId = (product) => {
  return product.prodpartno || product.generalProductId;
};

const getPdpUrl = (isBundleProduct, product) => {
  return `${isBundleProduct ? '/b' : '/p'}/${product.seo_token || product.uniqueId}`;
};

export const checkIfBundleProduct = (product) => {
  return (product.product_type && product.product_type.toLowerCase() === 'bundle') || false;
};

export const setPriceRange = (product) => {
  return {
    highListPrice: parseFloat(product.high_list_price) || 0,
    highOfferPrice: parseFloat(product.high_offer_price) || 0,
    lowListPrice: parseFloat(product.low_list_price) || 0,
    lowOfferPrice: parseFloat(product.low_offer_price) || 0,
  };
};

const checkIfL3Matches = (product, requiredL3) =>
  product.categoryPath3.find((category) => category === requiredL3);

const getL3Category = (shouldApplyUnbxdLogic, bucketingSeqConfig, product, catMap, childLength) => {
  let categoryName;
  for (let idx = 0; idx < childLength; idx += 1) {
    // DTN-7945: The product can be tagged in two L3's but as now we are triggering mutiple l3 calls in new UNBXD approach
    // The product will get tagged to the first match it finds in its own categoryPath3_fq. but ideally it should match the
    // current l3 for which the products are bieng fetched.
    const requiredL3 = processHelpers.getRequiredL3(shouldApplyUnbxdLogic, bucketingSeqConfig, idx);
    const temp = checkIfL3Matches(product, requiredL3);
    if (catMapExists(temp, catMap, bucketingSeqConfig)) {
      categoryName = temp;
    }
    // if category name is found then break the loop.
    if (categoryName) {
      break;
    }
  }
  return categoryName;
};

// Get L3 Category Id for Category Name from bucketingSeqConfig, if category name doesn't exist it'll return undefined.
const getL3CategoryId = (bucketingSeqConfig, categoryName, childLength) => {
  let categoryId;
  if (!categoryName) {
    return categoryId;
  }
  categoryId = processHelpers.getRequiredL3Id(bucketingSeqConfig, categoryName, childLength);
  return categoryId;
};

const calculateOutOfStock = (variants) => {
  let flag = false;
  if (variants) {
    variants.forEach((variant) => {
      if (variant?.v_qty <= 0) {
        flag = true;
      }
    });
  }
  return flag;
};

export function getInfluencerTags(product) {
  if (product?.influencer_tags) return JSON.parse(product.influencer_tags);
  return null;
}

export function getInfluencerPicks(product) {
  if (
    product?.influencer_pick &&
    Array.isArray(product?.influencer_pick) &&
    product?.influencer_pick?.length > 0
  ) {
    return product.influencer_pick;
  }
  return null;
}

const extractMerchant = (product, attributesNames) => {
  return product.TCPMerchantTagUSStore || extractAttributeValue(product, attributesNames.merchant);
};

export const parseProductInfo = (
  productArr,
  state,
  {
    isUSStore,
    getImgPath,
    hasShortImage,
    attributesNames,
    categoryType,
    excludeBadge,
    bucketingSeqConfig,
    shouldApplyUnbxdLogic,
    response,
    res,
    isRecommendationView,
  }
) => {
  const product = productArr;
  // confirmed with Sachin this true value will not break anything
  const isFromProductParser = true;
  const pdpInfo = isRecommendationView
    ? parseProductFromAPI(product, product.uniqueId, false, getImgPath, false, false)
    : [];
  // Make product list transformation
  product.list_of_attributes = attributeListMaker(product.list_of_attributes);
  const defaultColor = processHelpers.getDefaultColor(product);
  const { uniqueId } = product;
  const colorsArray = processHelpers.getColors(isUSStore, product, uniqueId, defaultColor);
  const colors = Array.isArray(colorsArray) ? [...new Set(colorsArray)] : colorsArray;
  const rawColors = processHelpers.getRawColors(isUSStore, product);
  const isBOPIS = isBopisEligibleProduct(isUSStore, product);
  const isBundleProduct = checkIfBundleProduct(product);
  const bossDisabledFlags = {
    bossProductDisabled: isBossProductDisabled(product),
    bossCategoryDisabled: isBopisProductDisabled(product),
  };
  const imageExtension = product.productimage || '';
  const imagesByColor = extractExtraImages(
    rawColors,
    product.alt_img,
    getImgPath,
    uniqueId,
    defaultColor,
    false,
    hasShortImage,
    imageExtension,
    isFromProductParser
  );
  const colorsMap = getColorsMap({
    uniqueId,
    product,
    attributesNames,
    categoryType,
    excludeBadge,
    isBOPIS,
    bossDisabledFlags,
    defaultColor,
    getImgPath,
    isBundleProduct,
    state,
    isFromProductParser,
    colors,
  });
  if (Array.isArray(colors)) {
    colors.forEach((color) => {
      const [productId, productColor] = color?.split('#') || [];
      // the default/selected one is already there
      const swatchOfAvailableProduct = res.body.response.products;
      if (colorDetailsCondition(productId, product, swatchOfAvailableProduct, uniqueId)) {
        colorsMap.push({
          colorProductId: productId,
          imageName: productId,
          miscInfo: {
            isBopisEligible: isBopisEligibleProduct(isUSStore, swatchOfAvailableProduct, product),
            isBossEligible: isBossEligibleProduct(bossDisabledFlags, product),
            hasOnModelAltImages: parseBoolean(
              extractAttributeValue(swatchOfAvailableProduct, attributesNames.onModelAltImages)
            ),
            badge1: extractPrioritizedBadge(
              swatchOfAvailableProduct,
              attributesNames,
              categoryType,
              excludeBadge,
              !isBundleProduct
            ),
            badge2: extractAttributeValue(swatchOfAvailableProduct, attributesNames.extendedSize),
            badge3: extractAttributeValue(swatchOfAvailableProduct, attributesNames.merchant),
            zoneOneBadges: extractZoneOneBadges(
              swatchOfAvailableProduct,
              attributesNames,
              categoryType
            ),
            zoneSixBadges: extractZoneSixBadges(
              swatchOfAvailableProduct,
              attributesNames,
              categoryType,
              isBundleProduct
            ),
            listPrice:
              parseFloat(product.TCPCustomListPrice) || getListPrice(swatchOfAvailableProduct),
            offerPrice:
              parseFloat(product.TCPCustomSalePrice) ||
              processHelpers.getOfferPrice(swatchOfAvailableProduct),
            keepAlive: parseBoolean(swatchOfAvailableProduct[attributesNames.keepAlive]),
          },
          color: {
            name: getColorNameForProductParser({
              uniqueId: productId,
              colorName: productColor,
              isFromProductParser,
              colors,
            }),
            imagePath: getImgPath(productId).colorSwatch,
            swatchImage: getImgPath(productId).colorSwatch,
          },
        });
      }
    });
  }
  let categoryName;
  let categoryId;
  const childLength = processHelpers.getChildLength(bucketingSeqConfig);
  const catMap = processHelpers.getCatMap(product, bucketingSeqConfig);
  // Check if the current product has a category path attribute which containes the categories it is the part of.
  if (product.categoryPath3) {
    categoryName = getL3Category(
      shouldApplyUnbxdLogic,
      bucketingSeqConfig,
      product,
      catMap,
      childLength
    );
    categoryId = getL3CategoryId(bucketingSeqConfig, categoryName, childLength);
  }
  const { isSearch } = response;
  pdpInfo.seoToken = product.seo_token;

  response.loadedProductsPages[0].push({
    styleWithData: pdpInfo,
    productInfo: {
      generalProductId: getGeneralProductId(product),
      name: product.product_name,
      pdpUrl: getPdpUrl(isBundleProduct, product),
      seoToken: product.seo_token,
      uniqueId: product.uniqueId,
      shortDescription: product.product_short_description,
      longDescription: product.product_short_description,
      // Meeting with Varun for alignment of this value.
      isGiftCard: processHelpers.isGiftCard(product),
      listPrice:
        parseFloat(product.TCPCustomListPrice) || processHelpers.getListPriceResponse(product),
      offerPrice:
        parseFloat(product.TCPCustomSalePrice) || processHelpers.getOfferPriceResponse(product),
      ratings: getRating(product),
      reviewsCount: getReview(product),
      unbxdRatings: getRating(product),
      unbxdReviewsCount: getReview(product),
      bundleProduct: isBundleProduct,
      unbxdId: getUnbxdIdFromReq(res.headers),
      promotionalMessage: getPromotionalMessage(product),
      promotionalPLCCMessage: getPromotionalPLCCMessage(product),
      long_product_title: product.long_product_title || '',
      priceRange: setPriceRange(product),
      isSearchFlag: isSearch,
      TCPMerchantTagUSStore: extractMerchant(product, attributesNames),
      tcpStyleType: extractAttributeValue(product, attributesNames.tcpStyle),
      tcpStyleQty: extractAttributeValue(product, attributesNames.tcpStyleQty),
      primaryBrand: extractAttributeValue(product, attributesNames.primaryBrand),
      TCPPromotionID: product.tcp_promotion_id,
      TCPPromotionPrice: product.tcp_promo_price,
      isOutOfStock: calculateOutOfStock(product.variants),
      varientCount: product.variantCount,
      variantDetails: extractAttributeValue(product, 'variantDetails'),
      hardMarkDown: product.is_hard_mark_enable,
      influencerTags: getInfluencerTags(product),
      influencerPicks: getInfluencerPicks(product),
      TCPPrimaryCategory: extractAttributeValue(product, attributesNames.primaryCategory),
      variantTotal: product.variantTotal,
      earlyAccessAvailability: product.early_access_availability,
    },

    uniqueId: product.uniqueId,
    miscInfo: {
      rating: getMiscInfoRating(product),
      // yet again, we need to dig from multiple sources just to get a simple string value
      categoryName,
      categoryId,
      isInDefaultWishlist: processHelpers.addingExtraProductInfo(product, state),
      isStoreSpecialEligible: parseBoolean(product?.store_specials),
    },
    categoryPath2: product.categoryPath2,
    TCPColor: product.TCPColor,
    categoryPath2_catMap: product.categoryPath2_catMap,
    colorsMap,
    imagesByColor,
    relatedSwatchImages:
      product.related_product_swatch_images && product.related_product_swatch_images.split(','),
    accessoriesData: getAccessoriesData(product),
  });
};

export const parseHPLPProductInfo = (
  productArr,
  state,
  {
    isUSStore,
    hasShortImage = '',
    categoryType = '',
    excludeBadge = '',
    allProducts, // pass all the products comming from data
  }
) => {
  const attributesNames = processHelpers.getProductAttributes();
  console.log('attributesNames', attributesNames);
  const product = productArr;
  // confirmed with Sachin this true value will not break anything
  const isFromProductParser = true;
  const pdpInfo = [];
  // Make product list transformation
  product.list_of_attributes = attributeListMaker(product.list_of_attributes);
  const defaultColor = processHelpers.getDefaultColor(product);
  const { uniqueId } = product;
  const colorsArray = processHelpers.getColors(isUSStore, product, uniqueId, defaultColor);
  const colors = Array.isArray(colorsArray) ? [...new Set(colorsArray)] : colorsArray;
  const rawColors = processHelpers.getRawColors(isUSStore, product);
  const isBOPIS = isBopisEligibleProduct(isUSStore, product);
  const isBundleProduct = checkIfBundleProduct(product);
  const bossDisabledFlags = {
    bossProductDisabled: isBossProductDisabled(product),
    bossCategoryDisabled: isBopisProductDisabled(product),
  };
  const imageExtension = product.productimage || '';
  const imagesByColor = extractExtraImages(
    rawColors,
    product.alt_img,
    getImgPathWithExtension,
    uniqueId,
    defaultColor,
    false,
    hasShortImage,
    imageExtension,
    isFromProductParser
  );
  const colorsMap = getColorsMap({
    uniqueId,
    product,
    attributesNames,
    categoryType,
    excludeBadge,
    isBOPIS,
    bossDisabledFlags,
    defaultColor,
    getImgPath: getImgPathWithExtension,
    isBundleProduct,
    state,
    isFromProductParser,
    colors,
  });
  if (Array.isArray(colors)) {
    colors.forEach((color) => {
      const [productId, productColor] = color?.split('#') || [];
      // the default/selected one is already there
      const swatchOfAvailableProduct = allProducts;
      if (colorDetailsCondition(productId, product, swatchOfAvailableProduct, uniqueId)) {
        colorsMap.push({
          colorProductId: productId,
          imageName: productId,
          miscInfo: {
            isBopisEligible: isBopisEligibleProduct(isUSStore, swatchOfAvailableProduct, product),
            isBossEligible: isBossEligibleProduct(bossDisabledFlags, product),
            hasOnModelAltImages: parseBoolean(
              extractAttributeValue(swatchOfAvailableProduct, attributesNames.onModelAltImages)
            ),
            listPrice:
              parseFloat(product.TCPCustomListPrice) || getListPrice(swatchOfAvailableProduct),
            offerPrice:
              parseFloat(product.TCPCustomSalePrice) ||
              processHelpers.getOfferPrice(swatchOfAvailableProduct),
            badge3: extractAttributeValue(swatchOfAvailableProduct, attributesNames.merchant),
            keepAlive: parseBoolean(swatchOfAvailableProduct[attributesNames.keepAlive]),
          },
          color: {
            name: getColorNameForProductParser({
              uniqueId: productId,
              colorName: productColor,
              isFromProductParser,
              colors,
            }),
            imagePath: getImgPathWithExtension(productId).colorSwatch,
            swatchImage: getImgPathWithExtension(productId).colorSwatch,
          },
        });
      }
    });
  }

  // Check if the current product has a category path attribute which containes the categories it is the part of.

  pdpInfo.seoToken = product.seo_token;
  return {
    styleWithData: pdpInfo,
    productInfo: {
      generalProductId: getGeneralProductId(product),
      name: product.product_name,
      pdpUrl: getPdpUrl(isBundleProduct, product),
      seoToken: product.seo_token,
      uniqueId: product.uniqueId,
      shortDescription: product.product_short_description,
      longDescription: product.product_short_description,
      // Meeting with Varun for alignment of this value.
      isGiftCard: processHelpers.isGiftCard(product),
      listPrice:
        parseFloat(product.TCPCustomListPrice) || processHelpers.getListPriceResponse(product),
      offerPrice:
        parseFloat(product.TCPCustomSalePrice) || processHelpers.getOfferPriceResponse(product),
      ratings: getRating(product),
      reviewsCount: getReview(product),
      unbxdRatings: getRating(product),
      unbxdReviewsCount: getReview(product),
      bundleProduct: isBundleProduct,
      promotionalMessage: getPromotionalMessage(product),
      promotionalPLCCMessage: getPromotionalPLCCMessage(product),
      long_product_title: product.long_product_title || '',
      priceRange: setPriceRange(product),
      TCPMerchantTagUSStore: product.TCPMerchantTagUSStore,
      tcpStyleType: extractAttributeValue(product, attributesNames.tcpStyle),
      tcpStyleQty: extractAttributeValue(product, attributesNames.tcpStyleQty),
      primaryBrand: extractAttributeValue(product, attributesNames.primaryBrand),
      TCPPromotionID: product.tcp_promotion_id,
      TCPPromotionPrice: product.tcp_promo_price,
      isOutOfStock: calculateOutOfStock(product.variants),
      varientCount: product.variantCount,
      variantDetails: extractAttributeValue(product, 'variantDetails'),
      hardMarkDown: product.is_hard_mark_enable,
      influencerTags: getInfluencerTags(product),
      influencerPicks: getInfluencerPicks(product),
      TCPPrimaryCategory: extractAttributeValue(product, attributesNames.primaryCategory),
    },

    uniqueId: product.uniqueId,
    miscInfo: {
      rating: getMiscInfoRating(product),
      // yet again, we need to dig from multiple sources just to get a simple string value
      isInDefaultWishlist: processHelpers.addingExtraProductInfo(product, state),
    },
    categoryPath2: product.categoryPath2,
    TCPColor: product.TCPColor,
    categoryPath2_catMap: product.categoryPath2_catMap,
    colorsMap,
    imagesByColor,
    relatedSwatchImages:
      product.related_product_swatch_images && product.related_product_swatch_images.split(','),
    accessoriesData: getAccessoriesData(product),
  };
};
